import React from 'react';
import axios from 'axios';
import { render, screen, cleanup, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Modal from './modal';

jest.mock('axios');

afterEach(cleanup);

describe('Modal', () => {
  describe('display modal', () => {
    test('renders expected content(search patients works)', async() => {
      const dInterviewDetailId = 1;
      const patientBirthday  = "19900101";
      const defaultIndexProps = []

      const promise = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}
          ]
        }
      });

      (axios.get as any).mockResolvedValue(promise);
      await act(() => promise);
      render(<Modal dInterviewDetailId={dInterviewDetailId}
                    patientBirthday={patientBirthday}
                    defaultIndexProps={defaultIndexProps} />);
      
      // screen.debug();

      expect(screen.getByText("患者情報の紐づけを行います")).toBeInTheDocument();
      expect(screen.getByText("検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)")).toBeInTheDocument();
      expect(screen.getByDisplayValue("19900101")).toBeInTheDocument();
      expect(screen.getByText("患者番号")).toBeInTheDocument();
      expect(screen.getByText("生年月日")).toBeInTheDocument();
      expect(screen.getByText("患者名(性別)")).toBeInTheDocument();
      expect(screen.getByText("携帯電話番号")).toBeInTheDocument();
      const serachButton = screen.getByText('検索');
      fireEvent.click(serachButton);
      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      // screen.debug();
    });
  });

  describe('link', () => {
    test('renders expected content', async() => {
      const dInterviewDetailId = 1;
      const patientBirthday  = "19900101";
      const defaultIndexProps = [{id: 1, name: "テスト患者A", status: 1, kanzyano: null}]

      const promise = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}
          ]
        }
      });

      const mock_d_interview_detail = Promise.resolve({
        data: {
          kanzyano: 'DEMO001',
          d_interview_detail: {id: 1, name: "テスト患者A"}
        }
      });

      (axios.get as any).mockResolvedValue(promise);
      (axios.patch as any).mockResolvedValue(mock_d_interview_detail);

      const {container} =  render(<Modal dInterviewDetailId={dInterviewDetailId}
                                         patientBirthday={patientBirthday}
                                         defaultIndexProps={defaultIndexProps} />);

      await act(() => promise);
      await act(() => mock_d_interview_detail);
      
      // screen.debug();

      const serachButton = screen.getByText('検索');
      fireEvent.click(serachButton);
      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();
      const tr = container.querySelector('#mpi1');
      fireEvent.click(tr);
      const linkButton = screen.getByText('紐づける');
      fireEvent.click(linkButton);
      // クラス名にinがないことでモーダルが消えていることを確認
      expect(await container.querySelector('#messageModal')).not.toHaveClass('in');

      // await screen.debug();
    });
  });
});